import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { MFormTextField, MTypography } from 'src/lib';
import { Account } from 'src/models';
import { Color, Spacing } from 'src/styles';

export interface TrustedContactViewProps {
  account?: Account;
}

export const TrustedContactView = ({ account }: TrustedContactViewProps) => {
  const renderPhoneNumberList = () => {
    return (
      account?.primaryAccountHolder?.trustedContact?.phones?.map(phone => {
        return (
          <Col span={24} key={phone.type}>
            {`+1${phone.phoneNumber} (${phone.type})`}
          </Col>
        );
      }) ?? <Col span={24} />
    );
  };

  return (
    <>
      <MFormTextField
        label='First Name'
        value={account?.primaryAccountHolder?.trustedContact?.firstName}
        testId={'account-first-name'}
      />
      <MFormTextField
        label='Last Name'
        value={account?.primaryAccountHolder?.trustedContact?.lastName}
        testId={'account-last-name'}
      />
      <MFormTextField
        label='Email'
        value={account?.primaryAccountHolder?.trustedContact?.email}
        testId={'account-email'}
      />
      <MFormTextField
        label='Phone Number(s)'
        value={<Row>{renderPhoneNumberList()}</Row>}
        testId={'account-phone-number'}
      />
      <MTypography variant='h5' weight='bold' color={Color.Gray8} className={cx(Spacing.mb32, Spacing.mt40)}>
        Address
      </MTypography>
      <MFormTextField
        label='Address Line 1'
        value={account?.primaryAccountHolder?.trustedContact?.address1}
        testId={'account-address1'}
      />
      <MFormTextField
        label='Address Line 2 (Opt.)'
        value={account?.primaryAccountHolder?.trustedContact?.address2}
        testId={'account-address2'}
      />
      <MFormTextField
        label='Country'
        value={account?.primaryAccountHolder?.trustedContact?.country?.label}
        testId={'account-country'}
      />
      <MFormTextField
        label='City'
        value={account?.primaryAccountHolder?.trustedContact?.city}
        testId={'account-city'}
      />
      <MFormTextField
        label='State'
        value={account?.primaryAccountHolder?.trustedContact?.state?.label}
        testId={'account-state'}
      />
      <MFormTextField
        label='Postal Code'
        value={account?.primaryAccountHolder?.trustedContact?.postalCode}
        testId={'account-postal-code'}
      />
    </>
  );
};
